import styled, { css } from 'styled-components';

import DropdownSearch from 'shared/components/DropdownSearch';
import InputFile from 'shared/components/inputfile';
import { colors } from 'shared/defaultTheme';
import MultipleSelectSearch from 'shared/components/MultipleSelectSearch';

export const FormWrapper = styled.form`
  display: block;
  margin-bottom: 30px;
  .button--primary {
    width: 120px;
  }
  .selected-contacts-container {
    box-sizing: border-box;
    height: 134px;
    border: 1px solid ${colors.pattens};
    border-radius: 4px;
    padding: 10px;
    overflow: auto;
    .selected-contacts-list {
      display: grid;
      grid-template-columns: repeat(4, max-content);
      padding-left: 0;
    }
  }
  .form-container {
    height: auto;
  }
  .group-input-container {
    margin-bottom: 43px;
  }
  .btn-action {
    height: 110px;
  }
  .btn-action-container {
    height: 170px;
    display: flex;
    flex-direction: row-reverse;
    align-items: flex-end;
  }
  .folder-view {
    margin-top: -105px;
  }
  .folder-view2 {
    margin-top: -30px;
  }
  .folder-view3 {
    margin-top: -90px;
  }
  .folder-view4 {
    margin-top: -99px;
  }
  .general-location-container {
    display: flex;
    .general-location-icon {
      border: none;
      background: transparent;
      position: absolute;
      right: 1px;
      top: 32px;
    }
  }
`;

export const GroupInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  padding-top: 8px;
  ${({ hidden }) => {
    return css`
      visibility: ${hidden ? 'hidden' : 'visible'};
    `;
  }}
`;

export const DocumentDropdownSearch = styled(DropdownSearch)`
  .selected-color {
    top: 39px;
  }
  height: 38px;
  border: 1px solid ${colors.pattens};
  border-radius: 4px;
  box-sizing: border-box;
`;

export const MultipleSelectSearchDocument = styled(MultipleSelectSearch)`
  .e-multiselect {
    margin-left: 0.3px;
  }
  border: 1px solid ${colors.pattens};
  border-radius: 4px;
  box-sizing: border-box;
`;

export const CustomInputFile = styled(InputFile)`
  .image-uploader__upload-input-section {
    height: 39px;
  }
`;

export const CustomInputComunicationName = styled.div`
  .title {
    font-family: 'MTTMilano-Medium', sans-serif;
    font-size: 14px;
    line-height: 16px;
    color: ${colors.black};
  }
  .input {
    border-radius: 4px;
    border: 1px solid #d6d8d9;
    padding: 6px !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &:hover {
      cursor: pointer;
    }
    .text {
      font-family: 'Roboto', sans-serif;
      font-size: 12px;
      line-height: 1.15;
    }
    .icon {
      .communication-icon {
        height: 20px;
        width: 20px;
      }
    }
  }
`;
